import type { TError, TValidatorValue, TValue } from '../models';

const VALID_STATUS = undefined;

export const composeValidators =
    (...validators: Array<(value: string, allValues: object) => TValidatorValue>) =>
    (value: string, allValues: object = {}) =>
        validators.reduce<TError>(
            (error, validator) => error || validator(value, allValues),
            VALID_STATUS
        );

export const validate = (value: TValue, defaultMessages = '', customMessage?: string) => {
    const validValue = value ? String(value).trim() : undefined;

    return validValue ? VALID_STATUS : customMessage || defaultMessages;
};
